// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TF3kB{padding:8px 16px}.pov3B{margin-top:8px}.UwJK4{display:flex;align-items:center;gap:8px;min-width:0}.hEICt{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.YuAhA{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sheetContent": `TF3kB`,
	"pickerSearch": `pov3B`,
	"mobileSummaryLine": `UwJK4`,
	"mobileSummaryText": `hEICt`,
	"mobileSummaryBadge": `YuAhA`
};
export default ___CSS_LOADER_EXPORT___;
